import { useTranslation } from "react-i18next";

const QualityManagementSection = () => {
  const { t } = useTranslation();
  const steps = t("qualityManagementSection.steps", { returnObjects: true });

  return (
    <section className="quality-management position-relative z-index-1 overflow-hidden">
      <div className="quality-management__stage">
        <span className="quality-management__orb quality-management__orb--one" />
        <span className="quality-management__orb quality-management__orb--two" />
        <span className="quality-management__orb quality-management__orb--three" />

        <div className="quality-management__content">
          <div className="section-heading style-left quality-management__heading">
            <h3 className="section-heading__title quality-management__title">
              {t("qualityManagementSection.title")}
            </h3>
          </div>

          <div className="quality-management__copy">
            <p>{t("qualityManagementSection.description")}</p>
            <p>{t("qualityManagementSection.cycleIntro")}</p>
          </div>

          <ul className="quality-management__steps">
            {steps.map((step, index) => (
              <li className="quality-management__step" key={index}>
                <span className="quality-management__arrow" aria-hidden="true" />
                <span>{step}</span>
              </li>
            ))}
          </ul>

          <p className="quality-management__result">
            {t("qualityManagementSection.result")}
          </p>
        </div>

        <div className="quality-management__visual" aria-hidden="true">
          <img
            src="/assets/images/thumbs/quality-section/quality-growth.png"
            alt=""
            className="quality-management__image"
          />
        </div>
      </div>
    </section>
  );
};

export default QualityManagementSection;
